<div class="wrapper" *ngIf="event?.event && cart">
  <app-hero-event class="w-100" [selectedEvent]="event.event"></app-hero-event>

  <div class="user-form-content">
    <div class="user-form-fields">
      <app-users-form-fields *ngIf="customerProfile" [isEventMembersExlusive]="isEventMembersExlusive" [eventProfileType]="eventProfileType" [customerProfile]="customerProfile" (changeShowPaymentEvent)="changeShowPayment($event)" [showPayment]="showPayment" [event]="event" [hasPayment]="hasPayment" [cardType]="orderInfo?.cardType" [connId]="connId" [orderId]="orderId"></app-users-form-fields>
    </div>
    <app-cart-info-box [cart]="cart" pageClass="order" class="w-m-100"></app-cart-info-box>
  </div>

  <div class="order-info-payment-container" id="order-payment" *ngIf="(showPayment === true)">
    <div class="user-form-content">
      <div class="user-form-content-wrapper">
        <app-payment-info paymentInfoMessages="tickets"></app-payment-info>
      </div>
    </div>
    <div class="user-form-content">
      <div class="user-form-content-wrapper w-100">
        <app-payment [cart]="cart" [orderId]="orderId" [hasPayment]="hasPayment" [orderInfo]="" [customerProfile]="customerProfile"></app-payment>
      </div>
    </div>
  </div>
</div>